import { unify } from "@lernetz/svelte-common/actions";
import { get, writable } from "svelte/store";
import { createField } from "./createField";

export type FieldNode = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

export function createForm<Values>(defaultValues: Values) {
  const store = writable(defaultValues);
  type Field = { name: keyof Values };

  const fields: Array<Field> = [];

  const addField = (field: Field) => {
    fields.push(field);
  };

  const removeField = (field: Field) => {
    const index = fields.indexOf(field);
    if (index !== -1) {
      fields.splice(index, 1);
    }
  };

  const isMultiNode = (name: keyof Values) => {
    return fields.filter((f) => f.name === name).length > 1;
  };

  const bind = (node: FieldNode, name: keyof Values) => {
    const field = createField(node, name, store, setValue, getValue, isMultiNode);
    addField(field);

    return unify([
      field.bind(),
      {
        destroy: () => {
          removeField(field);
        },
      },
    ]);
  };

  const setValue = (name: keyof Values, value: any) => {
    store.update((values) => {
      return {
        ...values,
        [name]: value,
      };
    });
  };

  const getValue = (name: keyof Values) => {
    return get(store)[name];
  };

  const reset = () => {
    store.set(defaultValues);
  };

  return {
    subscribe: store.subscribe,
    bind,
    setValue,
    getValue,
    reset,
  };
}

export type Form = ReturnType<typeof createForm>;
